export const focussableElements =
  'a:not([disabled]):not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input[type=text]:not([disabled]), textarea:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';

export function getFocussable(activeElement: Element) {
  return Array.prototype.filter.call(
    activeElement.querySelectorAll(focussableElements),
    function (element) {
      return (
        element.offsetWidth > 0 ||
        element.offsetHeight > 0 ||
        element === activeElement
      );
    }
  );
}

export function focusNextInElement(activeElement: Element | null) {
  if (document?.activeElement && activeElement) {
    const focussable = getFocussable(activeElement);
    const index = focussable.indexOf(document.activeElement);
    (focussable[index + 1] || focussable[0])?.focus();
  }
}

export function focusFirstInElement(activeElement: Element | null) {
  if (activeElement) {
    const focussable = getFocussable(activeElement);
    if (focussable.length) {
      focussable[0].focus();
    }
  }
}

export function focusPrevInElement(activeElement: Element | null) {
  if (document?.activeElement && activeElement) {
    const focussable = getFocussable(activeElement);
    const index = focussable.indexOf(document.activeElement);
    (focussable[index - 1] || focussable[focussable.length - 1])?.focus();
  }
}

export const findFocussableNextSiblingElem = (
  el: Element | null
): Element | null => {
  if (!el) {
    return null;
  }
  if (el.nextElementSibling && getFocussable(el.nextElementSibling).length) {
    return el.nextElementSibling;
  }
  return findFocussableNextSiblingElem(el.parentElement);
};

export const findFocussablePrevSiblingElem = (
  el: Element | null
): Element | null => {
  if (!el) {
    return null;
  }
  if (
    el.previousElementSibling &&
    getFocussable(el.previousElementSibling).length
  ) {
    return el.previousElementSibling;
  }
  return findFocussablePrevSiblingElem(el.parentElement);
};
